module.exports = __webpack_public_path__ + "img/banner_sonyday2.81a121ab.jpg";